import { Check, Pencil } from '@phosphor-icons/react'
import React, { useState } from 'react'

import Button from '@/components/shared/ui/Button'
import { SpinnerIcon } from '@/components/shared/ui/Icons'
import Input from '@/components/shared/ui/Input'
import { useHNUserContext } from '@/context/HNInteractorContext'
import { updateInteractor } from '@/models/User'
import toaster from '@/utils/toast'

export default function AdminSingleUserNameForm() {
  const { updateContext, ...userDetails } = useHNUserContext()
  const [formData, setFormData] = useState({
    name: userDetails?.name,
  })
  const [nameEditForm, setNameEditForm] = useState(false)
  const [updating, setUpdating] = useState(false)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!userDetails.id) return Promise.resolve()
    setUpdating(true)
    return updateInteractor(userDetails.id, formData)
      .then(updateContext)
      .then(() => setNameEditForm(false))
      .catch(toaster.error)
      .finally(() => {
        setUpdating(false)
      })
  }

  if (nameEditForm) {
    return (
      <form onSubmit={handleSubmit} className='flex items-center gap-2'>
        <Input
          type='name'
          defaultValue={userDetails.name}
          onChange={(e) => {
            setFormData({
              name: e.target.value,
            })
          }}
        />
        {!updating ? (
          <Button
            size='xs'
            variant='naked'
            disabled={updating}
            icon={<Check />}
          />
        ) : (
          <SpinnerIcon className='h-4 w-4' />
        )}
      </form>
    )
  }

  return (
    <div className='flex items-center gap-2'>
      <h4 className='text-lg font-medium'>{userDetails?.name}</h4>

      <Button
        size='xs'
        variant='naked'
        type={'button'}
        icon={<Pencil />}
        onClick={() => setNameEditForm(!nameEditForm)}
      />
    </div>
  )
}
